import type { IPlacesPort } from '@onboarding/application/ports';
import type { PlacePredictionDto, PlaceAddressDetailsDto } from '@onboarding/application/dtos';
import type { PlacesApiClientType } from '@onboarding/infrastructure/api/PlacesApiClient';
import type { PlacesApiMapperType } from '@onboarding/infrastructure/mappers/PlacesApiMapper';

/**
 * Concrete implementation of IPlacesPort.
 * Orchestrates PlacesApiClient and mapper to fulfill application contracts.
 */
export const createPlacesRepository = (props: {
  apiClient: PlacesApiClientType;
  mapper: PlacesApiMapperType;
}): IPlacesPort => {
  const { apiClient, mapper } = props;

  const fetchPredictions = async (input: string, country: string): Promise<PlacePredictionDto[]> => {
    const predictions = await apiClient.getPredictions(input, country);
    return mapper.mapPredictions(predictions);
  };

  const getPlaceDetails = async (placeId: string): Promise<PlaceAddressDetailsDto> => {
    const result = await apiClient.getDetails(placeId);

    if (!result) {
      throw new Error(`Place details not found for placeId: ${placeId}`);
    }

    return mapper.mapPlaceResultToAddress(result);
  };

  return { fetchPredictions, getPlaceDetails };
};
